import axios from "@/api/axiosInstance";
import { FetchRecurringEmailRecipientsResponse } from "./types";

export const fetchRecurringEmailRecipients = async (
  recurringEmail: string,
): Promise<FetchRecurringEmailRecipientsResponse> => {
  const response = await axios.get<FetchRecurringEmailRecipientsResponse>(
    `/api/private/recurring-emails/${recurringEmail}/recipients`,
  );
  return response.data;
};
